export default __webpack_public_path__ + "static/media/questionMark.b2d871a3.svg";